import Section from './Section'
import SectionActions from './SectionActions'
import SectionDivider from './SectionDivider'
import SubSection from './SubSection'

Section.Actions = SectionActions
Section.Divider = SectionDivider
Section.SubSection = SubSection

export default Section
